import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";
import { isNullUndefined } from "@/main/services/utils";
import { INITIAL_REDUCER_DATA } from "@/main/services/reducerUtils";
import { mountKeyParameterByTypeScreen } from "./parameterByTypeScreenUtils";
import { firstElementList } from "@/main/services/utilsArray";

export const useParameterByTypeScreenAllReducer = () =>
	useSelector((state: ApplicationState) => state.parameterByTypeScreen);

export const useParameterByTypeScreenReducer = (keyReducer: number) => {
	const returnSelector = useSelector((state: ApplicationState) => state.parameterByTypeScreen);
	const findedIsolated = returnSelector.isolated[mountKeyParameterByTypeScreen(keyReducer)] ?? INITIAL_REDUCER_DATA;
	const firstElement = firstElementList(findedIsolated.data);
	const valueFormatted = !isNullUndefined(firstElement) ? firstElement.value : null;
	return Number(valueFormatted);
};
